module.exports = __webpack_public_path__ + "img/教育-01.3f18115c.png";